export type LaunchPeriod = "pre_beta" | "beta" | "post_beta";

const PERIOD_BOUNDARIES = {
  // Pre-beta ends at midnight UTC on Feb 28, 2026
  preBetaEnd: new Date("2026-02-28T23:59:59Z"),
  // Beta ends at midnight UTC on Apr 30, 2026
  betaEnd: new Date("2026-06-30T23:59:59Z"),
};

export function getCurrentPeriod(): LaunchPeriod {
  const now = new Date();
  if (now <= PERIOD_BOUNDARIES.preBetaEnd) return "pre_beta";
  if (now <= PERIOD_BOUNDARIES.betaEnd) return "beta";
  return "post_beta";
}

export function isPreBeta(): boolean {
  return getCurrentPeriod() === "pre_beta";
}

export function isBeta(): boolean {
  return getCurrentPeriod() === "beta";
}

export function isPostBeta(): boolean {
  return getCurrentPeriod() === "post_beta";
}
